import { BasicClient } from '@/utils/httpClient';

export default class Folders {
    client;
    constructor() {
        this.client = new BasicClient();
    }

    getFoldersAvailable(params) {
        return this.client.exec(`/folders/available`, 'POST', params);
    }

    getDocumentTypeAvailable(params) {
        return this.client.exec(`/folders/documentTypes/available`, 'POST', params);
    }
    
    getFoldersUser(iduser) {
        return this.client.exec(`/v2/admin-mod/userfolder/` + iduser, 'GET');
    }

    addFoldersUser(params) {
        return this.client.exec(`/v2/admin-mod/userfolder`, 'POST', params);
    }

    deleteFoldersUser(iduser) {
        return this.client.exec(`/v2/admin-mod/userfolder/` + iduser, 'DELETE');
    }

    getFoldersSettingsAvailable() {
        return this.client.exec(`/v2/folders/available`, 'GET')
    }

    getSubFoldersAvailableForId(idFolder) {
        return this.client.exec('/v2/subfolders/available?id_carpeta=' + idFolder, 'GET')
    }

    updateSubFolder(subFolder) {
        return this.client.exec(`/v2/subfolder/update/${subFolder.id}`, 'PUT', subFolder)
    }

    getFoldersAndEforms() {
        return this.client.exec('/v2/admin-mod/documents/filtersType', 'GET')
    }
}